import { SdkStaff } from 'src/AppState/sdk/staff';
import { makeAutoObservable } from 'mobx';
import { Resource } from 'src_common/common/mobx-utils/Resource';
import { OpenapiProxyStaffAccountAffordabilityResponse200Type } from 'src/api_openapi/generated/openapi_proxy_staff_account_affordability';
import { TrpcClient } from 'src/AppState/TrpcClient';
import { pofWalletAggregate } from 'src_server/types/accountData';
import { getDepositLimits } from 'src_server/types/responsibleGambling';
import { getTransactionsTotalDeposits } from 'src_server/types/wallet';

export class CustomerSummaryTabState {
    public readonly affordabilityStatusResource: Resource<OpenapiProxyStaffAccountAffordabilityResponse200Type>;
    public readonly pofWalletAggregateResource: Resource<pofWalletAggregate.ResponseType> | null = null;
    public readonly depositLimitsResource: Resource<getDepositLimits.ResponseType> | null = null;
    public readonly transactionTotalDepositsResource: Resource<getTransactionsTotalDeposits.ResponseType>;

    public constructor(
        private readonly sdkStaff: SdkStaff,
        private readonly trpcClient: TrpcClient,
        private readonly customerId: number,
        private readonly isPof: boolean
    ) {
        this.affordabilityStatusResource = new Resource(
            async (): Promise<OpenapiProxyStaffAccountAffordabilityResponse200Type> => {
                return await this.sdkStaff.getAffordabilityStatus(this.customerId);
            }
        );
        this.depositLimitsResource = new Resource(async (): Promise<getDepositLimits.ResponseType> => {
            return await this.trpcClient.client.responsibleGamblingRouter.getDepositLimits.query({
                accountId: this.customerId,
            });
        });

        this.transactionTotalDepositsResource = new Resource(
            async (): Promise<getTransactionsTotalDeposits.ResponseType> => {
                return await this.trpcClient.client.walletRouter.getTransactionsTotalDeposits.query({
                    accountId: this.customerId,
                });
            }
        );

        if (this.isPof === true) {
            this.pofWalletAggregateResource = new Resource(async (): Promise<pofWalletAggregate.ResponseType> => {
                return await this.trpcClient.client.accountData.getPofWalletAggregate.query({
                    accountId: this.customerId,
                });
            });
        }
        makeAutoObservable(this);
    }
}
